<div class="wgu-container grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-4">
  <div class="card">
    <img
      alt="Setup User"
      class="img-responsive"
      src="/assets/images/landing/user.png"
      width="56"
    />

    <p class="card-title">Setup Your Account.</p>

    <p class="card-text">
      Activate your account through the claim process form.
    </p>

    <div>
      <a href="identityiq/external/claimProcess" class="text-link">Setup</a>
    </div>
  </div>

  <div class="card">
    <img
      alt="Reset Password"
      class="img-responsive"
      src="/assets/images/landing/pr.png"
      width="56"
    />

    <p class="card-title">Reset your password.</p>

    <p class="card-text">
      Activate your account through the claim process form.
    </p>

    <div>
      <a
        href="identityiq/external/forgotPassword/forgotPassword"
        class="text-link"
        >Reset</a
      >
    </div>
  </div>

  <div class="card">
    <img
      alt="Update Account"
      class="img-responsive"
      src="/assets/images/landing/edit_small.png"
      width="56"
    />

    <p class="card-title">Update your Account.</p>

    <p class="card-text">
      Update your account information.
    </p>

    <div>
      <p class="mp-6">Coming soon...</p>
      <!-- <a href="identityiq/updateAccount" class="text-link">Update</a> -->
    </div>
  </div>
</div>
